"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionType = exports.EmbeddedStatus = exports.RequestErrorCode = void 0;
var RequestErrorCode;
(function (RequestErrorCode) {
    RequestErrorCode["ENTITY_NOT_FOUND"] = "ENTITY_NOT_FOUND";
    RequestErrorCode["ENTITY_NOT_CREATED"] = "ENTITY_NOT_CREATED";
    RequestErrorCode["ENTITY_NOT_UPDATED"] = "ENTITY_NOT_UPDATED";
    RequestErrorCode["ENTITY_NOT_DELETED"] = "ENTITY_NOT_DELETED";
    RequestErrorCode["PROCESS_ERROR"] = "PROCESS_ERROR";
    RequestErrorCode["NO_FILE_PRESENT"] = "NO_FILE_PRESENT";
    RequestErrorCode["AUTH_INCORRECT_PASSWORD"] = "AUTH_INCORRECT_PASSWORD";
    RequestErrorCode["AUTH_NO_USER_FOUND"] = "AUTH_NO_USER_FOUND";
    RequestErrorCode["AUTH_FAILED"] = "AUTH_FAILED";
    RequestErrorCode["EMAIL_NOT_VERIFIED"] = "EMAIL_NOT_VERIFIED";
    RequestErrorCode["INVALID_FILE_TYPE"] = "INVALID_FILE_TYPE";
    RequestErrorCode["AUTH_SYSTEM_USER"] = "AUTH_SYSTEM_USER";
})(RequestErrorCode || (exports.RequestErrorCode = RequestErrorCode = {}));
var EmbeddedStatus;
(function (EmbeddedStatus) {
    EmbeddedStatus["NOT_PROCESSED"] = "NOT_PROCESSED";
    EmbeddedStatus["PROCESSED"] = "PROCESSED";
    EmbeddedStatus["TOO_LARGE"] = "TOO_LARGE";
    EmbeddedStatus["FORMAT_NOT_SUPPORTED"] = "FORMAT_NOT_SUPPORTED";
    EmbeddedStatus["SYSTEM_OUTAGE"] = "SYSTEM_OUTAGE";
    EmbeddedStatus["UNKNOWN"] = "UNKNOWN";
})(EmbeddedStatus || (exports.EmbeddedStatus = EmbeddedStatus = {}));
var QuestionType;
(function (QuestionType) {
    QuestionType["SHORT"] = "SHORT";
    QuestionType["LONG"] = "LONG";
    QuestionType["MULTIPLE"] = "MULTIPLE";
    QuestionType["EMAIL"] = "EMAIL";
    QuestionType["WEBSITE"] = "WEBSITE";
    QuestionType["DATE"] = "DATE";
    QuestionType["FILE_UPLOAD"] = "FILE_UPLOAD";
    QuestionType["NUMBER"] = "NUMBER";
    QuestionType["PHONE"] = "PHONE";
    QuestionType["CONTACT"] = "CONTACT";
    QuestionType["NPS"] = "NPS";
    QuestionType["SCORE"] = "SCORE";
    QuestionType["RATING"] = "RATING";
    QuestionType["SECTION"] = "SECTION";
    QuestionType["END"] = "END";
    // CHECKBOX = "CHECKBOX",  
    // TIME = "TIME",
})(QuestionType || (exports.QuestionType = QuestionType = {}));
